// The banner API every component uses (showSuccess, showError, closeBanner,
// the history toggle), over the app's banner store.

import { useBanner as useSharedBanner } from "@jkast90/kast-common/ui";
import { bannerStore } from "../utils/bannerStore";

export type { BannerType } from "@jkast90/kast-common/ui";

export function useBanner() {
  return useSharedBanner(bannerStore);
}
